module.exports = __webpack_public_path__ + "static/delivery_completed-50f7d27c66c43e5c623ee74e362607ea.gif";